module.exports = __webpack_public_path__ + "img/testimonials-6.5c194e6d.jpg";